export default __webpack_public_path__ + "media/icons/download-icon-d9133e0d.svg";